import { Box } from '@mantine/core';
import {
  IconAlertTriangleFilled,
  IconCircle,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleFilled,
  IconCircleX,
  IconCircleXFilled,
} from '@tabler/icons-react';
import { useMemo } from 'react';

import { TSDStatus } from '@e-origin/shared';

import { getStatusLabel } from '../utils';
import classes from './TSDStatusIndicator.module.css';

interface TSDStatusIndicatorProps {
  status: TSDStatus;
}

export const TSDStatusIndicator: React.FC<TSDStatusIndicatorProps> = ({ status }) => {
  const statusIconMapper = useMemo(
    () =>
      new Map([
        [TSDStatus.NOT_SENT, { icon: <IconCircle color="grey" />, alt: 'NOT_SENT' }],
        [TSDStatus.SENT, { icon: <IconCircleFilled color="blue" />, alt: 'SENT' }],
        [TSDStatus.PRELODGED, { icon: <IconCircleCheckFilled color="blue" />, alt: 'PRE_LODGED' }],
        [TSDStatus.PRESENTED, { icon: <IconCircle color="blue" />, alt: 'PRESENTED' }],
        [TSDStatus.LINKED, { icon: <IconCircleCheck color="blue" />, alt: 'LINKED' }],
        [TSDStatus.NOT_LINKED, { icon: <IconCircleX color="red" />, alt: 'NOT_LINKED' }],
        [TSDStatus.ACCEPTED, { icon: <IconCircleCheckFilled color="#69db7c" />, alt: 'ACCEPTED' }],
        [TSDStatus.INVALIDATED, { icon: <IconCircleXFilled color="grey" />, alt: 'INVALIDATED' }],
        [TSDStatus.UNDER_CONTROL, { icon: <IconCircleXFilled color="orange" />, alt: 'UNDER_CONTROL' }],
        [TSDStatus.IRREGULARITY_UNDER_INVESTIGATION, { icon: <IconAlertTriangleFilled color="orange" />, alt: 'IRREGULARITY_UNDER_INVESTIGATION' }],
        [TSDStatus.MEASURES_REQUIRED, { icon: <IconAlertTriangleFilled color="red" />, alt: 'MEASURES_REQUIRED' }],
        [TSDStatus.TEMPORARY_STORAGE_ENDED, { icon: <IconCircleCheckFilled color="green" />, alt: 'TEMPORARY_STORAGE_ENDED' }],
        [TSDStatus.REJECTED, { icon: <IconCircleXFilled color="red" />, alt: 'REJECTED' }],
        [TSDStatus.CLEARED, { icon: <IconCircleFilled color="green" />, alt: 'CLEARED' }],
      ]),
    [],
  );
  const currentStatus = statusIconMapper.get(status);

  const currentDescription = getStatusLabel(status);

  if (!currentStatus) {
    return null;
  }

  return (
    <Box display={'flex'}>
      <Box className={classes.svgIcon} title={currentDescription}>
        {currentStatus.icon}
      </Box>
    </Box>
  );
};
